import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'BadgesList',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items: string[];
}



return { __sfc: true,props }
}

})